var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('Header'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"zoom":"1"}},[_c('div',{staticClass:"zyrz"},[_c('p',[_c('img',{attrs:{"src":require("../assets/aaca_files/16273798142514707.jpg"),"title":"微信图片_20210727175554.jpg","alt":"微信图片_20210727175554.jpg"}})])])])
}]

export { render, staticRenderFns }